import React from 'react';

export const Card = ({
  children,
  header,
  footer,
  interactive = false,
  onClick,
  className = '',
  style = {},
  padding = '20px',
  ...props
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        backgroundColor: 'var(--surface-card)',
        boxShadow: interactive ? 'var(--shadow-raised-sm)' : 'var(--shadow-raised)',
        border: '1px solid var(--border-subtle)',
        borderRadius: 'var(--radius-card)',
        padding: padding,
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
        transition: 'all 0.22s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: interactive ? 'pointer' : 'default',
        ...style
      }}
      className={`${interactive ? 'interactive-raised' : ''} ${className}`}
      {...props}
    >
      {header && (
        <div
          style={{
            borderBottom: '1px solid var(--border-divider)',
            paddingBottom: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {header}
        </div>
      )}
      <div style={{ flex: 1 }}>{children}</div>
      {footer && (
        <div
          style={{
            borderTop: '1px solid var(--border-divider)',
            paddingTop: '12px',
            marginTop: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {footer}
        </div>
      )}
    </div>
  );
};
